export const adminPaths = Object.freeze({
  login: "/login",
  accessDenied: "/access-denied",
  root: "/admin",
  dashboard: "/admin/dashboard",
  users: "/admin/users",
  organizations: "/admin/organizations",
  ownershipTransfers: "/admin/organizations/ownership-transfers",
  jobs: "/admin/jobs",
  applications: "/admin/applications",
  courses: "/admin/courses",
  billing: "/admin/billing",
  support: "/admin/support",
  privacy: "/admin/privacy",
  referenceData: "/admin/reference-data",
  reports: "/admin/reports",
  announcements: "/admin/announcements",
  auditLogs: "/admin/audit-logs",
  operations: "/admin/operations",
  accessControl: "/admin/access",
});
